module.exports = __webpack_public_path__ + "img/no_filter_filled_32.64e192cc.svg";